import { Task } from "../models/Task";
import client from "./axios";

const tasksUrl = `${window.__env.CORE_URL}/tasks`;
const tenantTasksUrl = `${window.__env.BASE_URL}/tasks`;
const tenantTaskIstanceUrl = `${window.__env.BASE_URL}/task-instances`;
export const Tasks = {
  getTasks: () => client.get<Task[]>(tasksUrl),
  getTask: (id: string) => client.get<Task>(`${tasksUrl}/${id}`),
  getTenantTask: (id:string)=> client.get<Task>(`${tenantTasksUrl}/${id}`),
  getTenantTaskInstance: (id:number) => client.get<Task>(`${tenantTaskIstanceUrl}/${id}`),
  getTenantTaskInstanceConfig: (id:number) => client.get<Task>(`${tenantTaskIstanceUrl}/${id}/config`),
  createTask: (task: Task) => client.post<Task>(tasksUrl, task),
  updateTask: (task: Task) => client.put<Task>(`${tasksUrl}/${task.id}`, task),
  deleteTask: (id: number) => client.delete<Task>(`${tasksUrl}/${id}`),
}